export enum ReportBookEnum {
  STORY = 'STORY',
  EBOOK = 'EBOOK',
}
